"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpItemAnalysisChart = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var merge_1 = __importDefault(require("lodash/merge"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var DpChart_1 = require("../Charts/DpChart");
var defaultValues = {
    data: [],
    labels: [],
    datasetColors: [],
};
var DpItemAnalysisChart = function (_a) {
    var items = _a.items, options = _a.options, props = __rest(_a, ["items", "options"]);
    // ----------- Context
    var themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext);
    // ----------- State
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    var _c = (0, react_1.useState)((0, cloneDeep_1.default)(defaultValues)), chartDataset = _c[0], setChartDataset = _c[1];
    // ----------- Const
    var gridlinesColor = themeContext.Colors.Borders.hint;
    var barsColor = themeContext.Colors.success;
    var dataset = [
        {
            data: chartDataset.data,
            type: 'bar',
            backgroundColor: chartDataset.datasetColors,
            hoverBackgroundColor: chartDataset.datasetColors,
            barThickness: 30,
        },
    ];
    var chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    gridLines: {
                        drawTicks: false,
                        color: gridlinesColor,
                        borderDash: [2],
                        zeroLineColor: gridlinesColor,
                    },
                    ticks: {
                        fontStyle: 'bold',
                        callback: function (value) { return (value === 50 ? "".concat(value, "% ") : ''); },
                    },
                },
            ],
            xAxes: [
                {
                    ticks: {
                        lineHeight: 1.5,
                        fontStyle: 'bold',
                    },
                },
            ],
        },
    };
    (0, react_1.useEffect)(function () {
        if (!(0, isEmpty_1.default)(items)) {
            var itemAsChartModel = function (_a, _b) {
                var data = _a.data, labels = _a.labels, datasetColors = _a.datasetColors;
                var percentage = _b.percentage, label = _b.label;
                return ({
                    data: __spreadArray(__spreadArray([], data, true), [percentage], false),
                    labels: __spreadArray(__spreadArray([], labels, true), ["".concat(label)], false),
                    datasetColors: __spreadArray(__spreadArray([], datasetColors, true), [barsColor], false),
                });
            };
            setChartDataset(items.reduce(itemAsChartModel, (0, cloneDeep_1.default)(defaultValues)));
            setInitialized(true);
        }
    }, [items, barsColor]);
    return initialized ? ((0, jsx_runtime_1.jsx)(DpChart_1.DpChart, __assign({ datasets: dataset, labels: chartDataset.labels, options: (0, merge_1.default)(chartOptions, options || {}) }, props))) : null;
};
exports.DpItemAnalysisChart = DpItemAnalysisChart;
exports.default = exports.DpItemAnalysisChart;
